import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.less';
import Card from '../../Card';
import Link from '../../Link/WizardLink';

// eslint-disable-next-line react/prop-types
const Header = ({ course, school, translitString, locale, page }) => {
  const { location } = course;
  const address =
    location && Object.keys(location).length
      ? [location.city, location.street, location.zip_code]
      : [];
  if (location && location.house_number) {
    address.push(location.house_number);
  }

  return (
    <Link
      className={styles.schoolItem}
      route="courseShow"
      courses="courses"
      school={translitString(school.Name, true)}
      course={translitString(course.title, true)}
      id={course.shortId}
      locale={locale}
      page={page}
      name="wizard_card_link_course"
    >
      <div className={styles.wizardCard} name="wizard_card_link_course">
        <Card data={course} type="wizard" reference="wizard" />
      </div>
    </Link>
  );
};

Header.propTypes = {
  course: PropTypes.object,
  school: PropTypes.object,
};

Header.defaultProps = {
  course: {},
  school: {},
};

export default Header;
